module.exports = __webpack_public_path__ + "img/emoji/pepelovebananobet.8f2949a4066ade2d5dc8261fcb3e05e6.png";